import { useState } from 'react';
import { useTranslation } from 'react-i18next';
// eslint-disable-next-line no-restricted-imports
import { Confirm, Dropdown, Segment } from 'semantic-ui-react';

import { userHasPermission } from '../../../api/firebase/account';
import useAdminActions from '../../../hooks/useAdminActions';
import { showErrorToast, showSuccessToast } from '../../Shared/showToast';

const initialState = {
  loading: false,
  open: false,
  confirmation: { header: '', content: '' },
  selectedOption: null,
};

const UserManage = ({ user }) => {
  const [state, setState] = useState(initialState);
  const { resetUserPassword } = useAdminActions();
  const { t } = useTranslation();

  const userOptions = [
    {
      key: 'reset_password',
      value: 'reset_password',
      text: t('admin.users.passwordReset.action'),
      icon: 'key',
      permission: 'can_manage_users', // It's possible to define option level permissions.
      confirmation: {
        header: t('admin.users.passwordReset.action'),
        content: (
          <Segment basic className="no-adding">
            {t('admin.users.passwordReset.confirmationMessage')}
          </Segment>
        ),
      },
    },
  ];

  const handleConfirmation = async ({ value }) => {
    setState({
      ...initialState,
      loading: true,
    });

    try {
      switch (value) {
        case 'reset_password':
          await resetUserPassword(user.uid, user.email);
          // Password reset link sent successfully.
          showSuccessToast(
            t('admin.users.passwordReset.successTitle'),
            <>
              {t('admin.users.passwordReset.sentToMessage')} <b>{user.email}</b>
            </>
          );
          break;

        default:
          // Unknown option abort
          return;
      }
    } catch (error) {
      console.log(error);
      showErrorToast(t('admin.users.passwordReset.failureTitle'), t('admin.users.passwordReset.failureMessage'));
    }
    // Reset state.
    setState(initialState);
  };

  return (
    <>
      <Confirm
        header={state.confirmation.header}
        content={state.confirmation.content}
        open={state.open}
        onCancel={() => setState(initialState)}
        onClose={() => setState(initialState)}
        onConfirm={() => handleConfirmation(state.selectedOption)}
        confirmButton={t('common.yes')}
        size="small"
      />
      <Dropdown icon="cog" direction="left" loading={state.loading}>
        <Dropdown.Menu>
          <Dropdown.Menu scrolling>
            {userOptions.map((option) => {
              // If no permission is defined, it defaults to 'can_manage_users'.
              const permission = option.permission || 'can_manage_users';

              // If the user doesn't have permission, don't show the option
              if (!userHasPermission(permission)) return null;

              return (
                <Dropdown.Item
                  key={option.key}
                  {...option}
                  onClick={() =>
                    setState({
                      ...initialState,
                      selectedOption: option,
                      confirmation: option.confirmation,
                      open: true,
                    })
                  }
                />
              );
            })}
          </Dropdown.Menu>
        </Dropdown.Menu>
      </Dropdown>
    </>
  );
};

export default UserManage;
